import React, { useEffect, useState } from "react";
import MenuDrawer from "../../../components/MenuDrawer";
import AppBar from "../../../components/AppBar";
import {
  Box,
  Grid,
  Snackbar,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Close, PeopleAltOutlined } from "@mui/icons-material";
import {
  CreateDropDown,
  CreateHeader,
} from "../../../components/CreatePagesComponents";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance, { BASE_URL } from "../../../constants/config";
import { ErrorSnackbar } from "../../../components/CustomSnackbar";

const ReassignDrForm = () => {
  const [confirmation, setconfirmation] = useState(false);

  const [chooseDr, setchooseDr] = useState("");
  const [chooseSupervisor, setchooseSupervisor] = useState("");
  const [chooseBackup, setchooseBackup] = useState("");

  const [supervisorSiteId, setsupervisorSiteId] = useState("");
  const [drId, setdrId] = useState("");
  const [backupDrId, setbackupDrId] = useState();
  const [supervisorId, setsupervisorId] = useState("");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setconfirmation(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <Close fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  const [unassignedDoctors, setunassignedDoctors] = useState([]);

  const GetUnassignedDoctors = async () => {
    setloading(true);
    await axiosInstance
      .get(
        `${BASE_URL}/doctor_supervisor/getAllUnAssignedDoctors?customerId=${userData?.customerId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setloading(false);
        setunassignedDoctors(res.data?.allNotAssignedDoctors);
      })
      .catch((e) => {
        setloading(false);
      });
  };

  const { allSupervisors } = useSelector((state) => state.admin);

  const supervisorData = allSupervisors?.map((supervisor) => ({
    value: supervisor?.name,
    label: supervisor?.name,
    supervisorId: supervisor?.id,
    siteId: supervisor?.siteId,
  }));

  const doctorData = unassignedDoctors?.map((doctor) => ({
    value: doctor?.name,
    label: doctor?.name,
    doctorId: doctor?.id,
  }));

  const [backupDoctorData, setBackupDoctorData] = useState([]);

  const updateBackupDoctorOptions = (selectedDoctorId) => {
    const filteredDoctors = unassignedDoctors?.filter(
      (doctor) => doctor?.id !== selectedDoctorId
    );

    const backupDoctorOptions = filteredDoctors?.map((doctor) => ({
      value: doctor?.name,
      label: doctor?.name,
      doctorId: doctor?.id,
    }));

    setBackupDoctorData(backupDoctorOptions);
  };

  const handleMainDoctorChange = (value) => {
    setchooseDr(value);
    const selectedDoctorId = doctorData?.find(
      (doc) => doc?.value === value
    )?.doctorId;
    setdrId(selectedDoctorId);

    updateBackupDoctorOptions(selectedDoctorId);
  };

  const handleBackupDoctorChange = (value) => {
    setchooseBackup(value);
    const selectedBackupDoctorId = doctorData?.find(
      (doc) => doc?.value === value
    )?.doctorId;
    setbackupDrId(selectedBackupDoctorId);
  };

  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  const AssignDr = async () => {
    if (chooseDr === "" || chooseSupervisor === "") {
      seterror(true);
      seterrorMsg("Please fill all the fields");
    } else {
      setloading(true);
      await axiosInstance
        .post(
          `${BASE_URL}/doctor_supervisor/assignDoctorToSupervisor`,
          {
            doctorId: drId,
            supervisorId: supervisorId,
            siteId: supervisorSiteId,
            backupDoctorId: backupDrId,
            customerId: userData?.customerId,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          setloading(false);
          setconfirmation(true);
          setTimeout(() => {
            navigate("/supervisor/doctors/reassign-doctor-to-supervisor");
          }, 2000);
          setdrId("");
          setbackupDrId("");
          setchooseDr("");
          setchooseBackup("");
          setchooseSupervisor("");
        })
        .catch((e) => {
          setloading(false);
        });
    }
  };

  useEffect(() => {
    GetUnassignedDoctors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer supervisor />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={error}
        handleCloseError={seterror}
        errorMsg={errorMsg}
      />
      <Snackbar
        open={confirmation}
        autoHideDuration={6000}
        onClose={handleClose}
        message="New Providers has been reassigned successfully!"
        action={action}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "white",
            color: "black",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title={"Reassign Provider to Supervisor"} />

        {/* Main Grid */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12}>
            {/* Inner Box */}
            <Box bgcolor="#fff" width="100%" sx={{ borderRadius: "20px" }}>
              <Box
                mb={2}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                }}
              >
                {/* Header Box */}
                <CreateHeader
                  title={"Reassign Provider to Supervisor"}
                  btnTitle={"Reassign"}
                  onClick={AssignDr}
                  cancelFunc={() => navigate(-1)}
                />

                {/* Form */}
                <Box px={15} py={5}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CreateDropDown
                        value={chooseDr}
                        setValue={(value) => handleMainDoctorChange(value)}
                        title="Choose Provider"
                        Icon={PeopleAltOutlined}
                        data={doctorData || []}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CreateDropDown
                        value={chooseBackup}
                        setValue={(value) => handleBackupDoctorChange(value)}
                        title="Choose Backup Provider"
                        Icon={PeopleAltOutlined}
                        data={backupDoctorData || []}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CreateDropDown
                        value={chooseSupervisor}
                        setValue={(value) => {
                          setchooseSupervisor(value);
                          setsupervisorSiteId(
                            supervisorData?.find((sup) => sup.value === value)
                              ?.siteId
                          );
                          setsupervisorId(
                            supervisorData?.find((sup) => sup.value === value)
                              ?.supervisorId
                          );
                        }}
                        title="Choose Supervisor"
                        Icon={PeopleAltOutlined}
                        data={supervisorData || []}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ReassignDrForm;
